export type CalBooking = { uid?: string; startTime?: string };

type CalMessageData = {
  originator?: string;
  type?: string;
  data?: { iframeHeight?: number; distance?: number; uid?: string; startTime?: string };
};

export type ParsedCalMessage =
  | { type: "height"; height: number }
  | { type: "route" }
  | { type: "scroll"; distance: number }
  | { type: "booked"; booking: CalBooking }
  | null;

export function parseCalMessage(origin: string, sourceMatches: boolean, value: unknown): ParsedCalMessage {
  if (!sourceMatches || (origin !== "https://cal.com" && origin !== "https://app.cal.com")) return null;
  if (!value || typeof value !== "object") return null;
  const message = value as CalMessageData;
  if (message.originator !== "CAL") return null;
  if (message.type === "__dimensionChanged" && Number.isFinite(message.data?.iframeHeight)) {
    return { type: "height", height: Math.max(400, Math.min(2400, Number(message.data?.iframeHeight))) };
  }
  if (message.type === "__routeChanged") return { type: "route" };
  if (message.type === "__scrollByDistance" && Number.isFinite(message.data?.distance)) {
    return { type: "scroll", distance: Number(message.data?.distance) };
  }
  if (message.type === "bookingSuccessfulV2") {
    return { type: "booked", booking: { uid: message.data?.uid, startTime: message.data?.startTime } };
  }
  return null;
}